import { render, staticRenderFns } from "./veStuAssocActivityEdit.vue?vue&type=template&id=11807904&scoped=true"
import script from "./veStuAssocActivityEdit.vue?vue&type=script&lang=js"
export * from "./veStuAssocActivityEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11807904",
  null
  
)

export default component.exports